export enum EnforceMinimumBreakEnum {
  NONE = 'NONE',
  SOFT = 'SOFT',
  HARD = 'HARD'
}
